// extracted by mini-css-extract-plugin
export default {"statisticTitle":"StatisticPage_statisticTitle__Nb0tR","container":"StatisticPage_container__qEtUj"};